import { render } from "./SeStdTaxForm1120ssk.vue?vue&type=template&id=64e813d4"
import script from "./SeStdTaxForm1120ssk.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1120ssk.vue?vue&type=script&lang=js"

import "./SeStdTaxForm1120ssk.vue?vue&type=style&index=0&id=64e813d4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__